import React from 'react';
import Styles from './FormLoader.module.scss';

export default function FormLoader({ message = 'Please wait...' }){
    return (
        <div className={Styles.loaderOverlay}>
            <div className={Styles.loaderContainer}>
                <div className={Styles.preloader}>
                    <span></span>
                </div>
                <span className={Styles.loadingText}>{message}</span>
            </div>
        </div>
    );
};